export default {
      id: "time-usage",
      viewBox: "0 0 21 19",
      url: __webpack_public_path__ + "sprite.svg#time",
      toString: function () {
        return this.url;
      }
    }